import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import iconBack from '../../../../images/icon-chevron-left.svg';
import styles from './AvailabilityCalendar.module.css';
import { AnyIfEmpty } from 'react-redux';
import { AvailabilityRedirectionContext } from '../../../context/availabilityRedirection';

interface props {
    setShowLocker: (active: boolean) => void;
    setShowCalendar: (active: boolean) => void;
    setShowForm: (active: boolean) => void;
    setAddAvailabilityObj: AnyIfEmpty<object>;
}

const AvailabilityCalendar = ({ setShowLocker, setShowCalendar, setShowForm, setAddAvailabilityObj }: props) => {
    const availabilityRedirectionContext = useContext(AvailabilityRedirectionContext);
    const selectedDate = availabilityRedirectionContext?.availabilityData.selectedDate;

    const [value, onChange]: AnyIfEmpty<object> = useState(selectedDate ? new Date(selectedDate) : new Date());

    // const submitHandler = async () => {
    //     const selectedDate = availabilityRedirectionContext?.availabilityData.selectedDate;

    //     if (value.length === 2) {
    //         await setAddAvailabilityObj((prevState: Date) => {
    //             return {
    //                 ...prevState,
    //                 startDate: moment(value[0]).format('YYYY-MM-DD'),
    //                 endDate: moment(value[1]).format('YYYY-MM-DD'),
    //             };
    //         });
    //     }
    //     if (value.length === 1 || value.length === undefined) {
    //         await setAddAvailabilityObj((prevState: AnyIfEmpty<object>) => {
    //             return {
    //                 ...prevState,
    //                 startDate: moment(value[0]).format('YYYY-MM-DD'),
    //                 endDate: moment(value[0]).format('YYYY-MM-DD'),
    //             };
    //         });
    //     }

    //     setShowCalendar(false);
    //     setShowForm(true);
    // };


    const submitHandler = async () => {
        const startDate = moment(Array.isArray(value) ? value[0] : value ? value : selectedDate).format('YYYY-MM-DD');
        const endDate = moment(Array.isArray(value) ? (value[1] ? value[1] : value[0]) : value ? value : selectedDate).format('YYYY-MM-DD');

        await setAddAvailabilityObj((prevState: any) => {
            return {
                ...prevState,
                startDate,
                endDate,
            };
        });

        setShowCalendar(false);
        setShowForm(true);
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div
                    className={styles.back}
                    onClick={() => {
                        setShowCalendar(false);
                        setShowLocker(true);
                    }}>
                    <img src={iconBack} alt="back" />
                </div>
                <h2 className={styles.title}>Select Dates</h2>
            </div>
            <div className={styles.body}>
                <Calendar
                    minDate={new Date(moment().format())}
                    onChange={onChange}
                    next2Label={null}
                    allowPartialRange={true}
                    selectRange={true}
                    prev2Label={null}
                    defaultValue={
                        availabilityRedirectionContext?.availabilityData.selectedDate
                            ? new Date(availabilityRedirectionContext?.availabilityData.selectedDate)
                            : value
                    }
                // value={
                //     availabilityRedirectionContext?.availabilityData.selectedDate
                //         ? new Date(availabilityRedirectionContext?.availabilityData.selectedDate)
                //         : value
                // }
                />
                <div className={styles.btnWrapper}>
                    <button onClick={submitHandler}>Next</button>
                </div>
            </div>
        </div>
    );
};

export default AvailabilityCalendar;
